﻿import { extend } from './helpers.js';

export default class FurilloGoogleMaps {

    constructor(element, options) {

        const defaults = {
            apiKey: '',
            mapId: '',
            onMapLoaded: function(instance) {}
        };

        this.element = element;
        this.map = null;
        this.options = extend(defaults, options);

        this.init();
    }

    init() {
        const self = this;

        var loadMap = function () {
            const position = { lat: 63.113077, lng: 16.6372206 };

            const lat = parseFloat(self.element.getAttribute('data-position-lat'));
            const lng = parseFloat(self.element.getAttribute('data-position-lng'));

            if (!isNaN(lat))
                position.lat = lat;

            if (!isNaN(lng))
                position.lng = lng;
            
            self.map = new window.google.maps.Map(self.element,
                {
                    zoom: 4,
                    center: position,
                    mapId: self.options.mapId,
                    disableDefaultUI: true,
                    zoomControl: true
                });

            self.options.onMapLoaded(self);

            const markerSrc = self.element.getAttribute('data-marker-src');
            if (!markerSrc || markerSrc.length === 0)
                return;
            
            const marker = new window.google.maps.Marker({
                position: position,
                map: self.map,
                icon: {
                    url: markerSrc
                }
            });

            self.map.setZoom(13);
        };

        if (!window.google) {
            const script = document.createElement('script');
            script.id = 'googlemaps-api';
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + self.options.apiKey + '&libraries=geometry';
            script.async = false;
            script.onload = function () {
                loadMap();
            };
            document.body.append(script);
        } else {
            loadMap();
        }
    }
}
